module.exports = __webpack_public_path__ + "img/Payment_Flash_inactive.f3a53932.png";